import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsx as e } from "react/jsx-runtime";
import { Body as t } from "@vds-core/typography";
import { calculateRem as r } from "@vds-core/utilities";
import { ColorTokens as o } from "@vds-tokens/color";
import { LayoutTokens as n } from "@vds-tokens/layout";
import l from "styled-components";
var a = l.div.withConfig({
    displayName: "HelperTextWrapper",
    componentId: "VDS__sc-1cspc64-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n  box-sizing: border-box;\n  ", ";\n  ", ";\n"])), function (_ref) {
    var e = _ref.$helperTextPlacement;
    return "right" === e && "\n    position: relative;\n    width: 50%;\n    padding-top: 0px;\n    padding-left: ".concat(r(n.space["3X"].value), ";\n  ");
  }, function (_ref2) {
    var e = _ref2.$helperTextPlacement;
    return "bottom" === e && "\n    padding-top: ".concat(r(n.space["2X"].value), ";\n  ");
  }),
  i = function i(r) {
    var o = r.helperText,
      n = r.helperTextPlacement,
      l = r.disabled,
      i = r.surface,
      d = r.calculateHelperTextColor;
    return e(a, {
      "aria-hidden": "true",
      $helperTextPlacement: n,
      children: e(t, {
        size: "small",
        color: null == d ? void 0 : d(l, i),
        children: o
      })
    });
  };
i.defaultProps = {
  calculateHelperTextColor: function calculateHelperTextColor(e, t) {
    return e && "dark" !== t ? o.interactive.disabled.onlight.value : e && "dark" === t ? o.interactive.disabled.ondark.value : e || "dark" !== t ? o.elements.secondary.onlight.value : o.elements.secondary.ondark.value;
  }
};
export { i as default };